/**
 * 修正版 MediaGallery クラス - エラー修正済み
 */

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        
        // 重複初期化防止
        if (this.initialized) return;
        this.initialized = true;
        
        // 基本要素の初期化
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        
        this.mql = window.matchMedia('(min-width: 750px)');
        this.sectionId = this.dataset.section || this.closest('[data-section]')?.dataset.section;
        
        // 制御フラグ（統一）
        this.isUpdating = false;
        this.isProcessing = false;  // 追加
        this.lastUpdateTime = 0;
        this.updateTimeout = null;
        
        // バリアント連携用
        this.variantSyncEnabled = this.dataset.variantSync === 'true';
        this.mediaData = this.loadMediaData();
        
        // エラーハンドリング付き初期化
        try {
          this.init();
        } catch (error) {
          console.error('MediaGallery initialization error:', error);
        }
      }

      init() {
        if (!this.elements.viewer) {
          console.warn('MediaGallery viewer not found');
          return;
        }
        
        // イベントリスナー設定
        this.setupEventListeners();
        
        // サムネイル設定
        if (this.elements.thumbnails) {
          this.setupThumbnails();
        }
        
        // PubSub初期化（重複チェック付き）
        this.initPubSubSafe();
        
        // バリアント連携初期化
        if (this.variantSyncEnabled) {
          this.initVariantSync();
        }
        
        // レスポンシブ対応
        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
        
      }

      setupEventListeners() {
        // スライド変更監視（デバウンス付き）
        this.elements.viewer.addEventListener('slideChanged', (event) => {
          this.handleSlideChangeDebounced(event);
        });
        
        // ナビゲーションボタン
        const prevButton = this.querySelector('.slider-button--prev');
        const nextButton = this.querySelector('.slider-button--next');
        
        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.previousSlide();
          });
        }
        
        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.nextSlide();
          });
        }

        // 画像読み込みエラー対応
        this.setupImageErrorHandling();
      }

      setupThumbnails() {
  if (!this.elements.thumbnails) return;
  
  const thumbnailButtons = this.elements.thumbnails.querySelectorAll('button[data-target]');
  
  thumbnailButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      const targetMediaId = button.parentElement.dataset.target;
      if (targetMediaId) {
        this.setActiveMedia(targetMediaId, false);
      }
    });
  });
}


      setupImageErrorHandling() {
        const images = this.querySelectorAll('img');
        images.forEach(img => {
          img.addEventListener('error', (e) => {
            console.warn('Image failed to load:', e.target.src);
            // 代替処理または再試行
            this.handleImageError(e.target);
          });
          
          img.addEventListener('load', () => {
            // 読み込み成功時の処理
            img.classList.add('loaded');
          });
        });
      }

      handleImageError(img) {
        // 代替画像設定または再試行
        if (!img.dataset.retried) {
          img.dataset.retried = 'true';
          setTimeout(() => {
            img.src = img.src + '?retry=' + Date.now();
          }, 1000);
        } else {
          // 代替画像を設定
          img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="300"%3E%3Crect width="100%25" height="100%25" fill="%23f0f0f0"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3EImage not available%3C/text%3E%3C/svg%3E';
          img.alt = '画像を読み込めませんでした';
        }
      }

      // デバウンス付きスライド変更ハンドラー
      handleSlideChangeDebounced(event) {
        if (this.updateTimeout) {
          clearTimeout(this.updateTimeout);
        }
        
        this.updateTimeout = setTimeout(() => {
          this.handleSlideChange(event);
        }, 100);
      }

      // 修正版 handleSlideChange
      handleSlideChange(event) {
        if (this.isUpdating || this.isProcessing) {
          return;
        }
        
        // 処理中フラグ設定
        this.isProcessing = true;
        
        const currentElement = event.detail?.currentElement;
        if (!currentElement) {
          this.isProcessing = false;
          return;
        }
        
        try {
          // メディアIDを抽出
          const fullMediaId = currentElement.dataset.mediaId;
          const mediaId = fullMediaId ? fullMediaId.replace(`${this.sectionId}-`, '') : null;
          
          if (mediaId) {
            // バリアント選択器に通知
            document.dispatchEvent(new CustomEvent('mediaGallerySlideChanged', {
              detail: {
                mediaId: mediaId,
                sectionId: this.sectionId,
                source: 'gallery-slide'
              }
            }));
          }
          
          // UI状態更新
          this.updateThumbnailState(currentElement);
          this.updateSlideCounter(currentElement);
          this.announceSlideChange(currentElement);
          
        } catch (error) {
          console.error('handleSlideChange error:', error);
        } finally {
          // フラグリセット
          setTimeout(() => {
            this.isProcessing = false;
          }, 150);
        }
      }

      // PubSub安全初期化
      initPubSubSafe() {
        if (typeof window.subscribe !== 'function') {
          if (!window._pubSubSubscribers) {
            window._pubSubSubscribers = {};
          }
          
          window.subscribe = function(eventName, callback) {
            if (!window._pubSubSubscribers[eventName]) {
              window._pubSubSubscribers[eventName] = [];
            }
            window._pubSubSubscribers[eventName].push(callback);
            
            return function unsubscribe() {
              if (window._pubSubSubscribers[eventName]) {
                window._pubSubSubscribers[eventName] = 
                  window._pubSubSubscribers[eventName].filter(cb => cb !== callback);
              }
            };
          };
          
          window.publish = function(eventName, data) {
            if (window._pubSubSubscribers[eventName]) {
              window._pubSubSubscribers[eventName].forEach(callback => {
                try {
                  callback(data);
                } catch (error) {
                  console.error(`PubSub callback error for ${eventName}:`, error);
                }
              });
            }
          };
        }
      }

      initVariantSync() {
        // バリアント変更監視
        window.subscribe('variant:change', (data) => {
          if (data.sectionId === this.sectionId && data.source === 'variant-picker') {
            this.syncFromVariant(data.mediaId);
          }
        });
      }

      syncFromVariant(mediaId) {
        if (!mediaId || this.isProcessing) return;
        
        const targetMediaId = `${this.sectionId}-${mediaId}`;
        
        // 更新フラグを設定
        this.isUpdating = true;
        
        try {
          // ギャラリー切り替え
          const success = this.setActiveMedia(targetMediaId, false);
          
          if (success) {
          } else {
            console.warn(`Failed to sync variant media: ${targetMediaId}`);
          }
        } catch (error) {
          console.error('syncFromVariant error:', error);
        } finally {
          // フラグリセット
          setTimeout(() => {
            this.isUpdating = false;
          }, 300);
        }
      }

      setActiveMedia(mediaId, prepend = false) {
        if (!mediaId) {
          console.warn('setActiveMedia called with no mediaId');
          return false;
        }
        
        const targetSlide = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        
        if (!targetSlide) {
          console.warn(`Media not found: ${mediaId}`);
          // フォールバック：最初の画像を表示
          const firstSlide = this.elements.viewer.querySelector('[data-media-id]');
          if (firstSlide) {
            return this.setActiveMedia(firstSlide.dataset.mediaId, prepend);
          }
          return false;
        }
        
        // 既にアクティブな場合はスキップ
        if (targetSlide.classList.contains('is-active') && !prepend) {
          return true;
        }
        
        try {
          // アクティブ状態を更新
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach(slide => {
            slide.classList.remove('is-active');
          });
          
          targetSlide.classList.add('is-active');
          
          // スクロール位置を調整
          this.scrollToSlide(targetSlide);
          
          // メディア再生制御
          this.playActiveMedia(targetSlide);
          
          // サムネイル状態更新
          this.updateThumbnailState(targetSlide);
          
          // カウンター更新
          this.updateSlideCounter(targetSlide);
          
          return true;
          
        } catch (error) {
          console.error('setActiveMedia error:', error);
          return false;
        }
      }

      scrollToSlide(targetSlide) {
        const slider = targetSlide.parentElement;
        if (!slider) return;
        
        const slideWidth = targetSlide.offsetWidth;
        const containerWidth = slider.offsetWidth;
        const isMobile = window.innerWidth < 750;
        
        let scrollLeft;
        if (isMobile) {
          // モバイル：中央揃え
          scrollLeft = targetSlide.offsetLeft - (containerWidth - slideWidth) / 2;
        } else {
          // デスクトップ：左揃え
          scrollLeft = targetSlide.offsetLeft;
        }
        
        slider.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: this.isUpdating ? 'auto' : 'smooth'
        });
      }

      updateThumbnailState(activeSlide) {
        if (!this.elements.thumbnails || !activeSlide) return;
        
        const mediaId = activeSlide.dataset.mediaId;
        const targetThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        
        if (targetThumbnail) {
          // 全てのサムネイルからアクティブ状態を除去
          this.elements.thumbnails.querySelectorAll('button').forEach(button => {
            button.removeAttribute('aria-current');
            button.classList.remove('thumbnail--active');
          });
          
          // 対象サムネイルをアクティブに
          const button = targetThumbnail.querySelector('button');
          if (button) {
            button.setAttribute('aria-current', 'true');
            button.classList.add('thumbnail--active');
          }
          
          // サムネイルスクロール調整
          this.scrollThumbnailIntoView(targetThumbnail);
        }
      }

      updateSlideCounter(activeSlide) {
        const counter = this.querySelector('.slider-counter--current');
        if (counter && activeSlide) {
          const position = activeSlide.dataset.mediaPosition || '1';
          counter.textContent = position;
        }
      }

      scrollThumbnailIntoView(thumbnail) {
        if (!this.elements.thumbnails?.slider || !thumbnail) return;
        
        try {
          const container = this.elements.thumbnails;
          const containerRect = container.getBoundingClientRect();
          const thumbnailRect = thumbnail.getBoundingClientRect();
          
          // 表示範囲内かチェック
          if (thumbnailRect.left >= containerRect.left && 
              thumbnailRect.right <= containerRect.right) {
            return;
          }
          
          // スクロール調整
          if (this.elements.thumbnails.slider) {
            this.elements.thumbnails.slider.scrollTo({
              left: thumbnail.offsetLeft - (container.offsetWidth / 2) + (thumbnail.offsetWidth / 2),
              behavior: 'smooth'
            });
          }
        } catch (error) {
          console.warn('Thumbnail scroll error:', error);
        }
      }

      previousSlide() {
        const currentSlide = this.elements.viewer.querySelector('.is-active');
        const prevSlide = currentSlide?.previousElementSibling;
        
        if (prevSlide) {
          this.setActiveMedia(prevSlide.dataset.mediaId, false);
        } else {
          // 最初のスライドの場合、最後のスライドに移動
          const lastSlide = this.elements.viewer.querySelector('[data-media-id]:last-child');
          if (lastSlide) {
            this.setActiveMedia(lastSlide.dataset.mediaId, false);
          }
        }
      }

      nextSlide() {
        const currentSlide = this.elements.viewer.querySelector('.is-active');
        const nextSlide = currentSlide?.nextElementSibling;
        
        if (nextSlide) {
          this.setActiveMedia(nextSlide.dataset.mediaId, false);
        } else {
          // 最後のスライドの場合、最初のスライドに移動
          const firstSlide = this.elements.viewer.querySelector('[data-media-id]:first-child');
          if (firstSlide) {
            this.setActiveMedia(firstSlide.dataset.mediaId, false);
          }
        }
      }

      // ユーティリティメソッド
      extractMediaId(fullMediaId) {
        if (!fullMediaId) return null;
        const parts = fullMediaId.split('-');
        return parts[parts.length - 1];
      }

      loadMediaData() {
        const dataElement = document.getElementById(`gallery-media-data-${this.sectionId}`);
        if (dataElement) {
          try {
            return JSON.parse(dataElement.textContent);
          } catch (error) {
            console.warn('Failed to parse media data:', error);
          }
        }
        return null;
      }

      playActiveMedia(activeSlide) {
        // 全メディアを一時停止
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }
        
        // アクティブメディアを再生
        const deferredMedia = activeSlide.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      announceSlideChange(activeSlide) {
        if (!this.elements.liveRegion || !activeSlide) return;
        
        const position = activeSlide.dataset.mediaPosition || '1';
        const total = this.elements.viewer.querySelectorAll('[data-media-id]').length;
        
        this.elements.liveRegion.textContent = `画像 ${position} / ${total}`;
        
        // 2秒後にクリア
        setTimeout(() => {
          if (this.elements.liveRegion) {
            this.elements.liveRegion.textContent = '';
          }
        }, 2000);
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) => 
          slide.setAttribute('role', 'presentation')
        );
      }

      // スティッキーヘッダー対応
      preventStickyHeader() {
        const stickyHeader = document.querySelector('sticky-header');
        if (stickyHeader) {
          stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
      }
    }
  );
}

// グローバル初期化関数
window.initMediaGallery = function(sectionId) {
  const gallery = document.getElementById(`MediaGallery-${sectionId}`);
  if (gallery && !gallery.initialized) {
    gallery.initialized = true;
  }
};